import { isRunningAsInstalledPwa } from './pwaInstallEnvironment';

export const INBOX_HASH = '#messages';

export type WebPushEnableResult = 'subscribed' | 'denied' | 'unsupported' | 'skipped';

export function isWebPushSupported(): boolean {
  if (typeof window === 'undefined') return false;
  if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
    return false;
  }
  // Prompt and subscribe only from the installed app (Home Screen / desktop PWA), not a browser tab.
  return isRunningAsInstalledPwa();
}

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const normalized = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(normalized);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) {
    output[i] = raw.charCodeAt(i);
  }
  return output;
}
